// Grupo Country Homes: labels are applied by the backend (bridge and email
// webhook), so the dashboard only needs to know which channel each one
// belongs to and how to rank them when a row can show a single chip.
import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const URGENT_LABEL = 'urgente';

// Labels that trigger an automation instead of describing a state.
export const ACTION_LABELS = Object.freeze({
  RETURN_TO_AI: 'regresar-ia',
  RESET: 'reiniciar',
});

export const ADVISOR_ACTIVE_LABEL = 'asesor-activo';

// Sidebar order for each channel's "Etiquetas" section.
export const WHATSAPP_LABELS = Object.freeze([
  ADVISOR_ACTIVE_LABEL,
  'cerrado',
  'ia-activa',
  'pendiente-asesor',
  'sin-respuesta',
  URGENT_LABEL,
]);

export const EMAIL_LABELS = Object.freeze(['a-responder', 'automatizado']);

// "Leído" filter of the conversation list. A conversation counts as read once
// its assigned advisor has opened it (see Conversation#unread_incoming_messages).
export const READ_STATUS = Object.freeze({
  ALL: 'all',
  READ: 'read',
  UNREAD: 'unread',
});

// Tabs of "Mi bandeja de entrada".
export const CHANNEL_TAB = Object.freeze({
  ALL: 'all',
  EMAIL: 'email',
  WHATSAPP: 'whatsapp',
});

// A conversation row shows one chip: alerts first, then the handoff state.
const CHAT_STATE_LABELS = Object.freeze([
  'sin-respuesta',
  'pendiente-asesor',
  ADVISOR_ACTIVE_LABEL,
  'ia-activa',
  'cerrado',
]);

const EMAIL_STATE_LABELS = Object.freeze([
  ...EMAIL_LABELS,
  // Earlier email labels, still applied to conversations tagged before the
  // two above replaced them in the menu.
  'consultas-web-responder',
  'portales-responder',
  'consultas-web-automatico',
  'portales-automatico',
]);

const actionLabels = Object.values(ACTION_LABELS);

// Each channel ranks its own labels first: an email assigned to an advisor
// keeps showing "A responder". Urgency goes last because the priority
// indicator already shows it.
export const getRowLabel = (labels = [], { isEmail = false } = {}) => {
  const precedence = isEmail
    ? [...EMAIL_STATE_LABELS, ...CHAT_STATE_LABELS, URGENT_LABEL]
    : [...CHAT_STATE_LABELS, ...EMAIL_STATE_LABELS, URGENT_LABEL];
  const visible = labels.filter(label => !actionLabels.includes(label));
  return precedence.find(label => visible.includes(label)) || visible[0];
};

// WhatsApp reaches Chatwoot through Bird and an API channel.
export const isWhatsappInbox = inbox => inbox?.channel_type === INBOX_TYPES.API;

export const isEmailInbox = inbox => inbox?.channel_type === INBOX_TYPES.EMAIL;
